import React, { useState, useEffect, Fragment } from "react";
import localization from "assets/localization/localization";
import DivLayout from "components/sales/divLayout/divLayout";
import Layout from "components/sales/layout/layout";
const AddressListing = ({
  match,
  history,
  getClientAddressDetails,
  clientAddressListing,
}) => {
  // console.log("PAGE::ADDRESS-DETAILS" + JSON.stringify(clientAddressListing));
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    if (clientAddressListing != null) {
      setData(clientAddressListing);
    }
  }, [clientAddressListing]);

  useEffect(() => {
    if (
      getClientAddressDetails != null &&
      match.params.client_id != undefined
    ) {
      (async () => {
        setIsLoading(true);
        await getClientAddressDetails(match.params.client_id);
        setIsLoading(false);
      })();
    }
  }, [getClientAddressDetails, match.params.client_id]);
  return (
    <Layout title={localization.addressDetails} isGoback isLoading={isLoading}>
      {data?.length > 0 ? (
        <>
          {data.map((item, key) => (
            <>
              <div className="panel-card">
                <div className="panel-heading">
                  {"Address " + (key+1) }
                </div>
                <div className="panel-body">
                  <div className="details-listing">
                    <DivLayout
                      heading={`POC Name`}
                      data={item["registered_name"]||item["client_name"]}
                    ></DivLayout>
                    <DivLayout
                      heading={`PAN Number`}
                      data={(item["pan_number"] && item["pan_number"] != 0) ? item["pan_number"] : 'N/A' }
                    ></DivLayout>
                    <DivLayout
                      heading={`Client GST`}
                      data={item["client_gst"]}
                    ></DivLayout>
                    <DivLayout
                      heading={`State`}
                      data={item["state_name"]}
                    ></DivLayout>
                    <DivLayout
                      heading={`City`}
                      data={item["city_name"]}
                    ></DivLayout>
                    <DivLayout
                      heading={`Pincode`}
                      data={item["pincode"]}
                    ></DivLayout>
                    <DivLayout
                      heading={`Address Line 1`}
                      data={item["address_line_1"]}
                    ></DivLayout>
                    <DivLayout
                      heading={`Address Line 2`}
                      data={item["address_line_2"]}
                    ></DivLayout>
                    <DivLayout
                      heading={`Recon Client Address Id`}
                      data={item["recon_client_address_id"]}
                    ></DivLayout>
                  </div>
                </div>
              </div>
            </>
          ))}
        </>
      ) : null}
    </Layout>
  );
};

export default AddressListing;
